import React from 'react';

const Video = ({ selectedVideo }) => {
  return (
    <section id="video">
      {selectedVideo ? (
        <iframe src={selectedVideo} title="Project Video" width="100%" height="500px" />
      ) : (
        <p>No video selected</p>
      )}
    </section>
  );
};

export default Video;
